'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';

export class NavbarComponent {
  menu = [];

  isCollapsed = true;

  constructor(Auth, $state, $rootScope, $location) {
    'ngInject';

    this.isLoggedIn = Auth.isLoggedInSync;
    this.isAdmin = Auth.isAdminSync;
    this.getCurrentUser = Auth.getCurrentUserSync;
    this.$rootScope = $rootScope;
    this.$rootScope.public_page = false;

    Auth.isLoggedIn(function(loggedIn) {
        if(!loggedIn) {
          $location.path('/login');
        }
      });

    if (this.getCurrentUser().$promise) {
      this.getCurrentUser().$promise.then(user => {
        if (user.role === 'customer') {
          this.menu = [{
            title: 'Carousel',
            state: 'carousel',
            role: 'customer'
          }]
        } else {
          this.menu = [{
              title: '固件',
              state: 'firmwares'
            },
            {
              title: '测试组',
              state: 'betagroups'
            },
            {
              title: '应用',
              state: 'apps'
            },
            {
              title: '应用市场',
              state: 'appstore',
              roles: ['staff']
            },
            {
              title: 'Waveform',
              state: 'waveforms'
            },
            {
              title: 'BookList',
              state: 'booklist'
            },
            {
              title: 'JDOrder',
              state: 'jdOrder'
            },
            {
              title: '应用优化配置',
              state: 'appconfs',
              roles: ['staff']
            },
            {
              title: '大神码',
              state: 'codeappconfs',
              roles: ['staff']
            },
            {
              title: '用户手册',
              state: 'tutorial'
            },
            {
              title: '字典',
              state: 'dictionaries'
            },
            {
              title: 'MyScripts',
              state: 'myscripts'
            },
            {
              title: 'Carousel',
              state: 'carousel'
            },
            {
              title: '手写模板',
              state: 'writetpl'
            },
            {
              title: '屏保',
              state: 'screensavers'
            },
            {
              title: '分类',
              state: 'categories'
            },
            {
              title: '标签',
              state: 'tags'
            },
            {
              title: '外设固件',
              state: 'peripheral'
            },
            {
              title: 'TP固件',
              state: 'tpFirmwares'
            },
            {
              title: '字体',
              state: 'fonts'
            },
            {
              title: '设备认证',
              state: 'devicecert'
            },
            {
              title: '设备组',
              state: 'appconfgroups'
            },
            {
              title: '显示器',
              state: 'monitor'
            },
            {
              title: '输入法',
              state: 'keyboard'
            },
            {
              title: '设备配置',
              state: 'deviceconfigs'
            },
            {
              title: '设备管理',
              state: 'devices'
            }
          ];
        }

        if (user.role !== 'admin') {
          this.menu = this.menu.filter(item => {
            return item.roles && item.roles.indexOf(user.role) !== -1
          })
        }
        // $state.go(this.menu[0].state)
      })
    }
  }

}

export default angular.module('directives.navbar', [])
  .component('navbar', {
    template: require('./navbar.html'),
    controller: NavbarComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/navbar/navbar.component.js